(function (window, document, $) {
  'use strict';

  if (!$) return;

  var ROOT_SELECTOR = '[data-product-tabs-block]';
  var initializedRoots = [];

  function toBoolean(value) {
    return String(value) === 'true';
  }

  function sliderOptions(root) {
    var desktopColumns = parseInt(root.getAttribute('data-desktop-columns'), 10) || 5;
    var showArrows = toBoolean(root.getAttribute('data-show-arrows'));
    var showDots = toBoolean(root.getAttribute('data-show-dots'));

    return {
      mobileFirst: true,
      slidesToShow: 2,
      slidesToScroll: 1,
      infinite: false,
      arrows: false,
      dots: showDots,
      adaptiveHeight: false,
      responsive: [
        { breakpoint: 767, settings: { slidesToShow: 3, slidesToScroll: 1 } },
        { breakpoint: 991, settings: { slidesToShow: 4, slidesToScroll: 1 } },
        { breakpoint: 1199, settings: { slidesToShow: desktopColumns, slidesToScroll: 1, arrows: showArrows } }
      ]
    };
  }

  function initSlider(root, panel) {
    var slider = panel.querySelector('[data-product-slider]');
    if (!slider || !slider.children.length || !$.fn.slick) return;

    var $slider = $(slider);
    if ($slider.hasClass('slick-initialized')) {
      $slider.slick('setPosition');
      return;
    }

    if (slider.querySelector('.product-tabs-block__empty')) return;
    $slider.slick(sliderOptions(root));
  }

  function setPanelError(panel, message) {
    var status = panel.querySelector('[data-panel-status]');
    panel.classList.remove('is-loading');
    panel.setAttribute('data-loaded', 'false');
    if (status) status.textContent = message;
  }

  function loadPanel(root, panel) {
    if (!panel || panel.getAttribute('data-loading') === 'true') return;
    if (panel.getAttribute('data-loaded') === 'true') {
      initSlider(root, panel);
      return;
    }

    var url = panel.getAttribute('data-url');
    var slider = panel.querySelector('[data-product-slider]');
    var status = panel.querySelector('[data-panel-status]');
    var limit = parseInt(root.getAttribute('data-product-limit'), 10) || 10;

    if (!url || !slider) {
      setPanelError(panel, 'Select a collection for this tab.');
      return;
    }

    panel.setAttribute('data-loading', 'true');
    panel.classList.add('is-loading');
    if (status) status.textContent = '';

    $.ajax({ url: url, method: 'GET', dataType: 'html' })
      .done(function (html) {
        var holder = document.createElement('div');
        holder.innerHTML = html;
        var cards = Array.prototype.slice.call(holder.querySelectorAll('.product-tabs-block__slide'), 0, limit);

        slider.innerHTML = '';
        if (cards.length) {
          cards.forEach(function (card) { slider.appendChild(card); });
        } else {
          slider.innerHTML = '<div class="product-tabs-block__empty">No products found in this collection.</div>';
        }

        panel.setAttribute('data-loaded', 'true');
        panel.classList.remove('is-loading');
        if (status) status.textContent = '';
        initSlider(root, panel);
      })
      .fail(function () {
        setPanelError(panel, 'Products could not be loaded. Select this tab to try again.');
      })
      .always(function () {
        panel.removeAttribute('data-loading');
      });
  }

  function activateTab(root, tab, moveFocus) {
    if (!tab) return;
    var blockId = tab.getAttribute('data-product-tab');
    var tabs = root.querySelectorAll('[data-product-tab]');
    var panels = root.querySelectorAll('[data-product-panel]');
    var targetPanel = root.querySelector('[data-product-panel="' + blockId + '"]');

    Array.prototype.forEach.call(tabs, function (item) {
      var active = item === tab;
      item.classList.toggle('is-active', active);
      item.setAttribute('aria-selected', active ? 'true' : 'false');
      item.setAttribute('tabindex', active ? '0' : '-1');
    });

    Array.prototype.forEach.call(panels, function (panel) {
      var active = panel === targetPanel;
      panel.classList.toggle('is-active', active);
      panel.hidden = !active;
    });

    if (moveFocus) tab.focus();
    if (targetPanel) loadPanel(root, targetPanel);
  }

  function handleKeyboard(root, event) {
    var keys = ['ArrowLeft', 'ArrowRight', 'Home', 'End'];
    if (keys.indexOf(event.key) === -1) return;

    var tabs = Array.prototype.slice.call(root.querySelectorAll('[data-product-tab]'));
    var currentIndex = tabs.indexOf(event.currentTarget);
    var targetIndex = currentIndex;

    if (event.key === 'ArrowLeft') targetIndex = currentIndex <= 0 ? tabs.length - 1 : currentIndex - 1;
    if (event.key === 'ArrowRight') targetIndex = currentIndex >= tabs.length - 1 ? 0 : currentIndex + 1;
    if (event.key === 'Home') targetIndex = 0;
    if (event.key === 'End') targetIndex = tabs.length - 1;

    event.preventDefault();
    activateTab(root, tabs[targetIndex], true);
  }

  function updateVariant(card, swatch) {
    var image = card.querySelector('[data-product-image]');
    var variantId = swatch.getAttribute('data-variant-id');
    var imageSrc = swatch.getAttribute('data-image-src');
    var imageSrcset = swatch.getAttribute('data-image-srcset');

    Array.prototype.forEach.call(card.querySelectorAll('[data-product-swatch]'), function (item) {
      var active = item === swatch;
      item.classList.toggle('is-active', active);
      item.setAttribute('aria-pressed', active ? 'true' : 'false');
    });

    if (image && imageSrc) {
      image.src = imageSrc;
      if (imageSrcset) image.srcset = imageSrcset;
    }

    if (variantId) {
      Array.prototype.forEach.call(card.querySelectorAll('[data-product-link]'), function (link) {
        try {
          var nextUrl = new window.URL(link.href, window.location.origin);
          nextUrl.searchParams.set('variant', variantId);
          link.href = nextUrl.pathname + nextUrl.search + nextUrl.hash;
        } catch (error) {
          link.href = link.href.split('?')[0] + '?variant=' + variantId;
        }
      });
    }
  }

  function observeFirstPanel(root) {
    var activePanel = root.querySelector('[data-product-panel].is-active');
    if (!activePanel) return;

    if (!('IntersectionObserver' in window) || window.Shopify && window.Shopify.designMode) {
      initSlider(root, activePanel);
      return;
    }

    var observer = new window.IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        initSlider(root, activePanel);
        observer.disconnect();
      });
    }, { rootMargin: '250px 0px' });

    observer.observe(root);
    root.productTabsObserver = observer;
  }

  function initRoot(root) {
    if (!root || root.getAttribute('data-product-tabs-initialized') === 'true') return;
    root.setAttribute('data-product-tabs-initialized', 'true');
    initializedRoots.push(root);

    root.addEventListener('click', function (event) {
      var tab = event.target.closest('[data-product-tab]');
      if (tab && root.contains(tab)) {
        activateTab(root, tab, false);
        return;
      }

      var swatch = event.target.closest('[data-product-swatch]');
      if (swatch && root.contains(swatch)) {
        var card = swatch.closest('[data-product-card]');
        if (card) updateVariant(card, swatch);
      }
    });

    Array.prototype.forEach.call(root.querySelectorAll('[data-product-tab]'), function (tab) {
      tab.addEventListener('keydown', function (event) { handleKeyboard(root, event); });
    });

    observeFirstPanel(root);
  }

  function destroyRoot(root) {
    if (!root) return;
    if (root.productTabsObserver) root.productTabsObserver.disconnect();
    $(root).find('[data-product-slider].slick-initialized').slick('unslick');
    root.removeAttribute('data-product-tabs-initialized');
    initializedRoots = initializedRoots.filter(function (item) { return item !== root; });
  }

  function initAll(scope) {
    var context = scope || document;
    if (context.matches && context.matches(ROOT_SELECTOR)) initRoot(context);
    Array.prototype.forEach.call(context.querySelectorAll(ROOT_SELECTOR), initRoot);
  }

  $(function () { initAll(document); });

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    var root = event.target.matches && event.target.matches(ROOT_SELECTOR) ? event.target : event.target.querySelector(ROOT_SELECTOR);
    destroyRoot(root);
  });

  document.addEventListener('shopify:block:select', function (event) {
    var tab = event.target.closest && event.target.closest('[data-product-tab]');
    var root = tab && tab.closest(ROOT_SELECTOR);
    if (!root || !tab) return;
    activateTab(root, tab, false);
  });
})(window, document, window.jQuery);
